import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FilterChip } from '../enums & constants/filter-chips.constants';
import { Mirador } from '../models/mirador';
import { MiradorFilter } from '../models/mirador-filter';
import { BusinessCode } from '../models/business-code';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class OrganizerService {

  private isCarouselOpen = new BehaviorSubject<boolean>(false);
  public $isCarouselOpen = this.isCarouselOpen.asObservable();

  private isCarouselExperienceOpen = new BehaviorSubject<boolean>(false);
  public $isCarouselExperienceOpen = this.isCarouselExperienceOpen.asObservable();

  private isCurrentMiradorSelectedOpen = new BehaviorSubject<boolean>(false);
  public $isCurrentMiradorSelectedOpen = this.isCurrentMiradorSelectedOpen.asObservable();

  private focusMiradorAfterSelectMiradorURL = new BehaviorSubject<boolean>(false);
  public $focusMiradorAfterSelectMiradorURL = this.focusMiradorAfterSelectMiradorURL.asObservable();

  private shouldDisplayMiradorDetail = new BehaviorSubject<Mirador>(null);
  public $shouldDisplayMiradorDetail = this.shouldDisplayMiradorDetail.asObservable();

  private shouldDisplayMainMenu = new BehaviorSubject<boolean>(false);
  public $shouldDisplayMainMenu = this.shouldDisplayMainMenu.asObservable();

  private shouldOpenFeedBackPanel = new BehaviorSubject<boolean>(false);
  public $shouldOpenFeedBackPanel = this.shouldOpenFeedBackPanel.asObservable();

  private shouldAppearFilterChipBySearch = new BehaviorSubject<FilterChip>(null);
  public $shouldAppearFilterChipBySearch = this.shouldAppearFilterChipBySearch.asObservable();

  private shouldAppearNewFilterChipByList = new BehaviorSubject<FilterChip>(null);
  public $shouldAppearNewFilterChipByList = this.shouldAppearNewFilterChipByList.asObservable();

  private businessCode = new BehaviorSubject<BusinessCode>(null);
  public $businessCode = this.businessCode.asObservable();

  constructor() { }

  public setBusinessCode(code: string) {
    const currentTimestamp = moment().valueOf(); // Obtiene el timestamp actual
    const newBusinessCode = new BusinessCode(currentTimestamp, code);
    this.businessCode.next(newBusinessCode);
}

  getBusinessCode() {
    return this.businessCode.value;
  }

  setCarruselStatus(status: 'open'|'close') {
    console.log("setCarruselStatus => ", status);
    if(this.isCarouselOpen.value != (status == 'open'))
    this.isCarouselOpen.next(status == 'open');
  }

  setCarruselExperienceStatus(status: 'open'|'close') {
    if(this.isCarouselExperienceOpen.value != (status == 'open'))
    this.isCarouselExperienceOpen.next(status == 'open');
  }

  public setCurrentMiradorSelectedOpenStatus(status: boolean) {
    if(this.isCurrentMiradorSelectedOpen.value != (status))
    this.isCurrentMiradorSelectedOpen.next(status);
  }

  public shouldFocusMirador(value: boolean) {
    this.focusMiradorAfterSelectMiradorURL.next(value);
  }

  public setDisplayMiradorDetailStatus(item: Mirador) {
    this.shouldDisplayMiradorDetail.next(item);
  }

  public setDisplayMainMenuStatus(status: 'open'|'close') {
    if(this.shouldDisplayMainMenu.value != (status == 'open'))
    this.shouldDisplayMainMenu.next(status == 'open');
  }

  public setFeedBackPanelStatus(status: 'open'|'close') {
    this.shouldOpenFeedBackPanel.next(status == 'open');
  }

  public setFilterChipBySearch(filter: MiradorFilter[]) {
    let filterChipBySearch : FilterChip;

    if(filter) {
      filterChipBySearch = { ionicIcon: true, icon: "search-outline", label: filter[0].value, selected: true, filters : filter, type: 'Filter'};
      if(this.shouldAppearNewFilterChipByList.value) {
        this.shouldAppearNewFilterChipByList.next(null);
      }
    } else {
      filterChipBySearch =  null;

    }

    this.shouldAppearFilterChipBySearch.next(filterChipBySearch)
  }

  public setNewFilterChipByList(filter: MiradorFilter[]) {
    let newFilterChipByList : FilterChip;

    if (filter) {
      newFilterChipByList = { ionicIcon: true, icon: "list-outline", label: filter[0].value, selected: true, filters : filter, type: 'Filter'};
      if(this.shouldAppearFilterChipBySearch.value) {
        this.shouldAppearFilterChipBySearch.next(null);
      }
    }else {
      newFilterChipByList = null;
    }

    this.shouldAppearNewFilterChipByList.next(newFilterChipByList)

  }

}
